import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";

import ChildType from "@/types/child-type"
import { useCollection } from "@/hooks/resources";
import ChildAuthorizationType from "@/types/child-authorization-type";
import { useAppContext } from "@/contexts/app-context";

type ChildWithProfessionalsProps = {
  child: ChildType;
}

export const ChildWithProfessionals = ({ child }: ChildWithProfessionalsProps) => {
  const { t } = useTranslation("account-page")
  const [childAuthorizations, { isLoading }] = useCollection<ChildAuthorizationType>(`/child_authorizations?child_id=${child.id}`)
  const { state: { currentUser } } = useAppContext()

  return (
    <div className="card w-full px-4 py-3 flex gap-4 items-center justify-between">
      <div>
        <div>{child.fullName}</div>
        {
          currentUser?.entitlements.includes("shared-child-authorization-access")
            ? (
              <Link to={`/invite-professional?child_id=${child.id}`} className="text-sm link text-gray-500 underline">
                Invite a Professional to work with {child.fullName}
              </Link>
            )
            : (
              <p className="text-sm text-gray-500">
                <Link to="/select-membership" className="link link-secondary">Upgrade to Premium</Link> to link your child&apos;s account with professionals.
              </p>
            )
        }
      </div>

      <div>
        {
          !isLoading && childAuthorizations
            ? (
              <>
                <div className="text-sm text-gray-500">{t("workingWithProfessionals", { count: childAuthorizations.length })}</div>

                <ul className="flex flex-col items-end text-sm">
                  {
                    (childAuthorizations || []).map(childAuthorization => (
                      <li key={childAuthorization.id}>{childAuthorization.user.fullName}</li>
                    ))
                  }
                </ul>
              </>
            )
            : (
              <Skeleton count={2} className="h-4" containerClassName="w-48 block" />
            )
        }
      </div>
    </div>
  )
}
